export default __webpack_public_path__ + "static/media/softclix_lancets@2x.e6d73366.webp";